import { useLanguage } from "../../../context/hook/useLanguageContext";
import templateSlider from "./Slider.template";

const Slider =()=>{
  const { language } = useLanguage();

  return templateSlider(language);
}

export default Slider;